export const EXISTED_FILENAME_ERROR_MESSAGE = 'The filename is not unique';
